import http from '@/utils/ajax'
import { RISK_FACTOR_INIT_LOADING, RISK_FACTOR_INIT_SUCCESS, RISK_FACTOR_INIT_FAIL, RISK_FACTOR_COMMIT_KEY } from '@/store/types'
import { extractMenu, extractMessages } from '@/utils/extract'

export const state = {
  // Agency level init (bring in menu for specific modules eg: travel motor etc)
  // 0: Loading, 1: Success, 2: Fail
  init: 0,
  initErr: [],
  menu: {},
  riskFact: {
    riskFactId: {
      riskFactMode: null,
      factor: null
    }
  }
}

const getters = {

}

const mutations = {
  [RISK_FACTOR_INIT_LOADING](state, err) {
    state.init = 0
    state.initErr = []
    state.menu = {}
  },
  [RISK_FACTOR_INIT_SUCCESS](state, data) {
    state.init = 1
    state.initErr = []
    state.menu = data.menu
  },
  [RISK_FACTOR_INIT_FAIL](state, err) {
    state.init = 2
    state.initErr = err
    state.menu = {}
  },
  [RISK_FACTOR_COMMIT_KEY](state, data) {
    state.riskFact.riskFactId.riskFactMode = data.riskFactMode
    state.riskFact.riskFactId.factor = data.factor
  }
}

const actions = {
  async riskFactManagementInit({ commit, rootState }) {
    const apiUrl = rootState.app.menu.riskFactManagementController
    commit(RISK_FACTOR_INIT_LOADING)
    try {
      const result = await http.get(apiUrl)
      const menu = extractMenu(result.data._links)
      const commitResult = {
        menu: menu
      }
      commit(RISK_FACTOR_INIT_SUCCESS, commitResult)
    } catch (err) {
      commit(RISK_FACTOR_INIT_FAIL, extractMessages(err))
    }
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
